import { Observable } from "rxjs/Observable";
import { IRequestAction, progressEpic } from "epics/base-epic";
import { POS } from "constants/action-types";
import { IPOSStatus } from "constants/order-types";
import siteConfig from "site-config";
import { IPosStatusMap } from "reducers/pos";

interface Action extends IRequestAction {
    id: string;
}

export const fetch = progressEpic<Action, IPosStatusMap>(
    POS.STATUS.FETCH,
    ({ payload }) => ({ method: "GET", url: siteConfig.api + payload.url }),
    {
        // allow multiple pending requests at the same time
        mapper: "mergeMap",
        // on 404 return NOT_EXPORTED status, do not throw
        checkError: (error) => {
            if (error.status !== 404) {
                return Observable.throw(error);
            }
            return Observable.of({
                response: { status: IPOSStatus.NOT_EXPORTED },
                status: 200,
                xhr: error.xhr,
            });
        },
        dataCustomizer: (response, { payload }, store) => ({
            ...store.pos.status.payload,
            [payload.id]: response.status ?? IPOSStatus.NOT_EXPORTED,
        }),
    },
);
